module.exports = __webpack_public_path__ + "static/LOGO-LANDINGPAGE-WANCLOUDS.5b47536b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO-LANDINGPAGE-WANCLOUDS.png
// module id = 516
// module chunks = 35783957827783